import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Safety net: clear any leftover styles/classes that could block scroll
    // on the newly-navigated page (especially after offcanvas open/close).
    document.body.classList.remove("qb-open");
    document.body.classList.remove("modal-open");
    document.body.classList.remove("offcanvas-open");

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.documentElement.style.overflow = "";
    document.documentElement.style.paddingRight = "";

    // Remove any stray offcanvas backdrops that may have been left behind.
    document.querySelectorAll(".offcanvas-backdrop").forEach((b) => b.remove());

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
